
import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const saveNotificationApi = async (panelistId, message, type) => {
  return securePost("/api/user/savePointWalletNotification", { panelistId, message, type });
};

export const getNotificationApi = async (panelListId, type) => {
  return secureGet("/api/user/getPointWalletNotification", { panelListId, type });
};

export const markReadNotificationApi = async (panelistId, notificationIds, type) => {
  return securePost("/api/user/markReadPointWalletNotification", { panelistId, notificationIds, type });
};

export const getNotificationCountApi = async (panelListId) => {
  return secureGet("/api/user/countPointWalletNotification", { panelListId });
};
